import * as actionTypes from 'modules/localStorage/actionTypes';
import type { SaveAction, SaveFailureAction } from 'modules/localStorage/types';

export const save = (): SaveAction => ({
  type: actionTypes.SAVE,
});

export const saveFailure = (message: unknown): SaveFailureAction => ({
  type: actionTypes.SAVE_FAILURE,
  payload: {
    message,
  },
  error: true,
});
